<template>
	<div class="memberW newsW clearfloat">
		<div class="left">
			<ul class="partList" v-if="list.length > 0">
				<li class="clearfloat" v-for="(item,index) in list" :key="index" style="top: 0px; opacity: 1;">
					<div class="partPic"><div class="pic">
						<router-link :to="{ name: 'newsDetail', query: { id: item.id }}"><img :src="item.coverUrl" alt="" class="pic_img"></router-link>
						</div></div>
					<div class="cont">
						<h3><router-link :to="{ name: 'newsDetail', query: { id: item.id }}">{{item.title}}</router-link></h3>
						<p class="ellipsis-2">{{item.subTitle}}</p>
						<h4>{{item.createTime}}</h4>
					</div>
				</li>
			</ul>

			<div class="tit" v-else>
					暂无数据
			</div>

			<el-pagination
					class="page pageNews"	
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="current"
					:page-size="size"
					layout="total, prev, pager, next"
					:total="total">
			</el-pagination>
		</div>
		<div class="right animate" style="top: 0px; opacity: 1;">
			<div class="memberSearch clearfloat">
				<input class="text" type="text" name="" v-model="keyword" id="" value="" placeholder="Search" />
				<input class="sub" type="submit" name="" @click="search" id="" value="搜索" />
			</div>
			<h2>热门推荐</h2>
			<ul class="newsWqlist">
				<li v-for="(item,index) in hotList" :key="index">
					<a class="clearfloat" href="">
						<div class="newsWqPic">
							<div class="pic"><img :src="item.coverUrl" alt="" /></div>
						</div>
						<div class="cont">
							<h3 class="multi-line1 ellipsis-2" v-html="item.title"></h3>
							<p>{{item.createTime}}</p>
						</div>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
/**
 * 描述
 * @description 描述
 * @property {String}
 * @example <aby-botton-line  />
 */

export default {
	props: {},
	data() {
		return {
			list: [],
			hotList:[],
			current:1,
			size:6,
			total:0,
			keyword:''
		};
	},
	computed: {},
	created(obj) {
		// 页面第一次加载执行，参数为上个页面传递的数据，参数类型为Object
		this.getNotices()
		this.getNoticesHot()
	},
	methods: {
		getNotices(isHome = 0){
			let reqInfo = {};
			reqInfo.type = this.$route.query.type || 'art';
			reqInfo.current = this.current;
			reqInfo.size = this.size;
			reqInfo.showContent = 1;
			reqInfo.keyword = this.keyword;
			this.$api.Home.getNotices(reqInfo,res => {
				let resData = res.data.records;
			  this.list = resData
				this.total = res.data.total
			},err=>{
				console.log(err)
			})
		},
		// 获取热门推荐
		getNoticesHot(){
			let reqInfo = {};
			reqInfo.type = this.$route.query.type || '';
			reqInfo.current = 1;
			reqInfo.size = 3;
			reqInfo.showContent = 1;
			reqInfo.orderByViews = 1;
			this.$api.Home.getNotices(reqInfo,res => {
				let resData = res.data.records;
			  this.hotList = resData
			},err=>{
				console.log(err)
			})
		},
		search(){
			this.current = 1;
			this.getNotices()
		},
		handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.current = val
			this.getNotices()
		}
	},
	watch: {
		$route(){
			 this.current = 1;
			 this.getNotices()	
  	},
		obj: {
			//监听的对象
			deep: true, //深度监听设置为 true
			handler: function(newV, oldV) {
				console.log('watch中：', newV);
			}
		}
	}
};
</script>

<style scoped>
.pic_img{
	height: 225px;
	width: 100%;
}

>>> .multi-line1{
	margin-bottom: 4px;
    color: #9C9C9C;
    line-height: 24px;
    font-family: "\5FAE\8F6F\96C5\9ED1";
		
}
>>> .multi-line1  p{
		margin-bottom: 4px;
    color: #9C9C9C !important;
    line-height: 24px;
    font-family: "\5FAE\8F6F\96C5\9ED1";
}
</style>
